import type { RawCategoryTreeNode } from "../../../../../types";
import type { CategoryNode } from "../../types/productTaxonomyApiTypes";

/**
 * Recursive helper to transform raw category nodes from the backend (snake_case)
 * into the camelCase structure used by the frontend components.
 *
 * This ensures consistency across the application while supporting
 * infinitely nested hierarchies.
 *
 * @param node The raw category node from the custom API response.
 * @returns A transformed CategoryNode object.
 */
export const transformCategoryNode = (
  node: RawCategoryTreeNode,
): CategoryNode => ({
  id: node.id,
  parent: node.parent,
  name: node.name,
  slug: node.slug,
  description: node.description,
  count: node.count,
  link: node.link,
  image: node.image,
  showcase: node.showcase,
  // Map backend snake_case to frontend camelCase
  menuOrder: node.menu_order,
  // Recursively transform children if they exist
  children: Array.isArray(node.children)
    ? node.children.map(transformCategoryNode)
    : [],
});
